<template>
  <div class="container">
    <!-- 头部标题 -->
    <header class="header-wrap">
      <div class="header">
        <h1 @click="goPage(0)">
          <img src="https://saasm.360che.com.cn/postertpl/img/logo-blue.png"
               alt="卡车之家" />
          卡车之家
        </h1>
        <h2 class="title">经销商入驻</h2>
        <span class="to-login">
          已有账号？
          <em @click="goPage(1)">去登录<i>&#xe826;</i></em>
        </span>
      </div>
    </header>
    <div class="content">
      <!-- 进度条 -->
      <h5 class="page-title">注册账号</h5>
      <speed-line :progress="progress"></speed-line>
      <!-- 悬浮窗 -->
      <floating-window :progress="progress"></floating-window>
      <router-view @changeLine="changeLine"></router-view>
    </div>
    <global-footer></global-footer>
  </div>
</template>

<script>
import SpeedLine from '@/components/SpeedLine.vue'
import FloatingWindow from '@/components/FloatingWindow.vue'
import GlobalFooter from '@/components/GlobalFooter.vue'
export default {
  name: 'DealerRegister',
  components: {
    SpeedLine,
    FloatingWindow,
    GlobalFooter
  },
  data () {
    return {
      progress: 1
    }
  },
  methods: {
    changeLine (progress) {
      this.progress = progress
    },
    goPage (num) {
      const json = {
        0: 'https://www.360che.com',
        1: 'https://kashangbao.360che.com/index.html'
      }
      window.open(json[num])
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  .page-title {
    font-size: 20px;
    color: #17181a;
    line-height: 30px;
    margin: 20px;
    font-weight: normal;
  }
  .header-wrap {
    height: 60px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    .header {
      width: 1300px;
      height: 60px;
      margin: 0 auto;
      padding: 5px 0;
      vertical-align: middle;
      h1 {
        width: 116px;
        height: 46px;
        overflow: hidden;
        font-size: 30px;
        font-weight: bold;
        color: #2459a6;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
      }
      .title {
        margin-left: 6px;
        vertical-align: middle;
        display: inline-block;
        font-size: 16px;
        color: #17181a;
        letter-spacing: 0;
        line-height: 45px;
      }
      .to-login {
        float: right;
        color: #999;
        font-size: 16px;
        font-size: 14px;
        color: #5c6066;
        text-align: right;
        line-height: 42px;
        em {
          color: #25a6ff;
          cursor: pointer;
          i {
            font-family: 'dealer';
          }
        }
      }
    }
  }
  .content {
    width: 1300px;
    min-height: 700px;
    padding-bottom: 20px;
    margin: 20px auto 30px;
    background: #ffffff;
    border: 1px solid #e4e5e6;
    background: #ffffff;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DealerRegister.vue